import $ from 'jquery';
import autosize from 'autosize';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';

let lastAssignee = null;

Component('tr-todo-form', {
  mixins: [eventListenerMixin, editorFormMixin, editorDraftMixin],

  properties: {
    focus: {
      type: String,
    },

    attachmentKey: {
      type: String,
    },

    focusOnReady: {
      type: Boolean,
      value: true,
    },

    create: {
      type: Boolean,
      value: false,
    },

    rememberLastAssignee: {
      type: Boolean,
      default: false,
    },

    projectSelectorUrl: {
      type: String,
    },
  },

  connected() {
    this.labelField = this.querySelector('.todo-label-select tr-combo-select-field');
    this.contentField = this.querySelector('.todo-content-input textarea');
    this.dueAtField = this.querySelector('tr-todo-date-field');
    this.attachment = this.querySelector('tr-todo-attachments');
    this.attachmentFileList = this.querySelector('tr-todo-attachments .file-list');
    this.assigneeField = this.querySelector('.todo-assignee-select tr-combo-select-field');
    this.descEditor = this.querySelector('.todo-desc-editor');
    this.button = this.querySelector('button[type="submit"]');

    this.contentField.rows = 1;
    autosize(this.contentField);

    this.listenTo(this.attachment, {
      'tr-todo-attachments:beforeupload': () => {
        if (this.button.getAttribute('disabled')) return;
        this.button.setAttribute('disabled', true);
        this.button.dataset.originText = this.button.innerHTML;
        this.button.innerHTML = '正在上传附件...';
      },
      'tr-todo-attachments:uploadcomplete': () => {
        this.button.removeAttribute('disabled');
        this.button.innerHTML = this.button.dataset.originText;
      },
    });

    this.listenTo(this.contentField, {
      compositionstart: () => { this.isInputComposing = true; },
      compositionend: () => { this.isInputComposing = false; },
      keydown: (e) => {
        if (this.isInputComposing || e.isComposing || e.keyCode === 229) return;

        if (e.key === 'Enter' || e.keyCode === 13) {
          e.stopPropagation();
          e.preventDefault();

          if (e.ctrlKey || e.metaKey) {
            this.contentField.value = `${this.contentField.value}\n`;
            autosize.update(this.contentField);
          } else {
            this.button.click();
          }
        }
      },
    });

    this.linkDue = this.querySelector('.link-toggle-due');
    if (this.linkDue) {
      this.listenTo(this.linkDue, 'click', (e) => {
        e.target.remove();
        this.showDatePicker();
      });
    }

    this.linkEditor = this.querySelector('.link-toggle-editor');
    if (this.linkEditor) {
      this.listenTo(this.linkEditor, 'click', (e) => {
        e.target.remove();
        this.descEditor.focus();
      });
    }

    this.listenTo(this.querySelector('.cancel-button'), 'mousedown', () => {
      if (!closest(this, 'tr-dialog')) this.remove();
      this.updateEditAction();
    });

    this.assigneeSelect = this.querySelector('.todo-assignee-select tr-combo-select-field');
    this.listenTo(this.assigneeSelect, 'tr-combo-select-field:change', () => {
      lastAssignee = this.assigneeSelect.getValue();
    });
  },

  ready() {
    this.setDuePlaceholder();
    this.setRangePlaceholder();
    this.initForm();
    if (this.focusOnReady) this.setFocus();
    if (this.projectSelectorUrl) {
      this.projectField = this.querySelector('#todo-form-project-field');
      this.todolistField = this.querySelector('#todo-form-todolist-field');

      this.listenTo(this.projectField, 'tr-combo-select-field:change', (e) => {
        const value = e.detail;
        this.fetch({
          project_guid: value,
        });
      });
      this.listenTo(this.todolistField, 'tr-combo-select-field:change', (e) => {
        const value = e.detail;
        this.fetch({
          project_guid: this.projectField.getValue(),
          todolist_guid: value,
        });
      });
    }
  },

  fetch(params = {}) {
    $.ajax({
      url: this.projectSelectorUrl,
      method: 'get',
      data: params,
      dataType: 'script',
    });
  },

  setFocus() {
    if (this.focus === 'content') {
      this.contentField.focus();
    } else if (this.focus === 'assignee') {
      const el = this.querySelector('.todo-assignee-select .mdc-select__selected-text');
      if (el) el.dispatchEvent(new Event('focusin'));
    } else if (this.focus === 'date') {
      const el = this.querySelector('.link-toggle-due');
      if (el) el.remove();
      this.showDatePicker();
    } else if (this.focus === 'range') {
      const el = this.querySelector('.link-toggle-due');
      if (el) el.remove();
      this.showRangePicker();
    } else if (this.focus === 'desc') {
      if (this.linkEditor) this.linkEditor.remove();
      this.descEditor.focus();
    } else if (this.focus === 'label') {
      const el = this.querySelector('tr-todo-label-field .search-input');
      if (el) setTimeout(() => el.focus(), 0);
    }
  },

  disconnected() {
    this.stopListening();
    this.namespacedTrigger('removed');
  },

  beforeCache() {
    this.remove();
  },

  initForm() {
    $(this).on('ajax:beforeSend', '.tr-form', (e, xhr, settings) => {
      const attachments = this.querySelectorAll('tr-todo-attachments .file');
      let params = '';
      if (attachments.length) {
        params = Array.prototype.map
          .call(attachments, el => `${this.attachmentKey}=${el.getAttribute('attachid')}`)
          .join('&');
      } else {
        params = `${this.attachmentKey}=''`;
      }
      // eslint-disable-next-line no-param-reassign
      settings.data += `&${params}`;
    });

    $(this).on('ajax:complete', '.tr-form', () => {
      this.updateEditAction();
    });

    if (this.create && this.rememberLastAssignee && lastAssignee) {
      this.assigneeSelect.setValue(lastAssignee);
    }
  },

  updateEditAction() {
    const editAction = document.querySelector('.detail-edit-action');
    if (editAction) editAction.classList.remove('edit');
  },

  setDuePlaceholder() {
    const field = this.querySelector('tr-date-field');
    if (!field) return;
    const input = field.querySelector('.flatpickr-input');
    if (!input) return;

    input.placeholder = field.getAttribute('placeholder');
  },

  setRangePlaceholder() {
    const field = this.querySelector('tr-date-range-field');
    if (!field) return;
    const input = field.querySelector('.flatpickr-input');
    if (!input) return;

    input.placeholder = field.getAttribute('placeholder');
  },

  showDatePicker() {
    const radio = this.querySelector('#scheduling_due_date_only');
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change'));
  },

  showRangePicker() {
    const radio = this.querySelector('#scheduling_due_date_with_start');
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change'));
  },
});
